import Link from "next/link";

export default function HeroSection() {
  return (
    <section className="bg-white pt-36 pb-32 px-5 md:px-20 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col gap-6 items-center justify-center">
        {/* Badge */}
        <div className="bg-[#fff5f2] rounded-full pt-2 pr-4 pb-2 pl-4 flex flex-row gap-2 items-center justify-start">
          <div className="bg-[#ff5733] rounded-full w-2 h-2 shrink-0" />
          <span className="text-[#ff5733] font-medium text-sm leading-5">
            AI-Powered Collections Platform
          </span>
        </div>

        {/* Heading */}
        <h1 className="text-center font-['SpaceGrotesk-Bold',_sans-serif] text-5xl md:text-6xl lg:text-7xl leading-tight font-bold max-w-4xl">
          <span className="text-[#111827]">Transform Loan Recovery with </span>
          <span className="text-[#ff5733]">Intelligent AI</span>
        </h1>

        {/* Description */}
        <p className="text-[#4b5563] text-center font-normal text-lg md:text-xl leading-relaxed max-w-3xl">
          DebtPulse is an AI-powered digital collections platform designed for
          NBFCs and fintech lenders in India - helping you prioritize
          high-risk accounts, automate compliant outreach, and improve
          recovery rates in real time.
        </p>

        {/* CTA Buttons */}
        <div className="pt-2 flex flex-col sm:flex-row gap-4 items-center justify-center w-full">
          <Link
            href="/contact?ref=debtpulse"
            className="bg-[#ff5733] rounded-lg pt-4 pr-8 pb-4 pl-8 flex flex-row gap-2 items-center justify-center"
          >
            <span className="text-white text-center font-bold text-lg leading-7">
              Request a Demo
            </span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.16797 10H15.8346" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10 4.16406L15.8333 9.9974L10 15.8307" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <a
            href="https://debtpulse.cloudastra.co/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-lg border border-[#d1d5db] pt-4 pr-8 pb-4 pl-8 flex flex-row gap-0 items-center justify-center shadow-sm"
          >
            <span className="text-[#111827] text-center font-bold text-lg leading-7">
              Explore DebtPulse
            </span>
          </a>
        </div>

        {/* Trust Badges */}
        <div className="pt-8 flex flex-col sm:flex-row gap-4 md:gap-6  lg:gap-12 items-center justify-center w-full">
          {/* RBI-aligned */}
          <div className="bg-white rounded-3xl py-3 pr-10 px-4 flex flex-row gap-3 items-center justify-start shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]">
            <div className="bg-[#dcfce7] rounded-3xl flex items-center justify-center w-10 h-10 shrink-0">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10 18C14.4153 18 18 14.4153 18 10C18 5.58468 14.4153 2 10 2C5.58468 2 2 5.58468 2 10C2 14.4153 5.58468 18 10 18V18M13.707 8.707C14.086 8.31462 14.0806 7.69092 13.6948 7.30518C13.3091 6.91945 12.6854 6.91403 12.293 7.293L9 10.586L7.707 9.293C7.31462 8.91403 6.69092 8.91945 6.30518 9.30518C5.91945 9.69092 5.91403 10.3146 6.293 10.707L8.293 12.707C8.6835 13.0974 9.3165 13.0974 9.707 12.707L13.707 8.707V8.707" fill="#16A34A" />
              </svg>
            </div>
            <span className="text-[#374151] font-medium text-sm leading-5">RBI-aligned</span>
          </div>

          {/* Multi-channel */}
          <div className="bg-white rounded-3xl py-3 pr-10 px-4 flex flex-row gap-3 items-center justify-start shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]">
            <div className="bg-[#dbeafe] rounded-3xl flex items-center justify-center w-10 h-10 shrink-0">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10 18C14.4153 18 18 14.4153 18 10C18 5.58468 14.4153 2 10 2C5.58468 2 2 5.58468 2 10C2 14.4153 5.58468 18 10 18V18M13.707 8.707C14.086 8.31462 14.0806 7.69092 13.6948 7.30518C13.3091 6.91945 12.6854 6.91403 12.293 7.293L9 10.586L7.707 9.293C7.31462 8.91403 6.69092 8.91945 6.30518 9.30518C5.91945 9.69092 5.91403 10.3146 6.293 10.707L8.293 12.707C8.6835 13.0974 9.3165 13.0974 9.707 12.707L13.707 8.707V8.707" fill="#2563EB" />
              </svg>
            </div>
            <span className="text-[#374151] font-medium text-sm leading-5">Multi-channel</span>
          </div>

          {/* Deploy in hours */}
          <div className="bg-white rounded-3xl py-3 pr-10 px-4 flex flex-row gap-3 items-center justify-start shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]">
            <div className="bg-[#fff5f2] rounded-3xl flex items-center justify-center w-10 h-10 shrink-0">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10 18C14.4153 18 18 14.4153 18 10C18 5.58468 14.4153 2 10 2C5.58468 2 2 5.58468 2 10C2 14.4153 5.58468 18 10 18V18M13.707 8.707C14.086 8.31462 14.0806 7.69092 13.6948 7.30518C13.3091 6.91945 12.6854 6.91403 12.293 7.293L9 10.586L7.707 9.293C7.31462 8.91403 6.69092 8.91945 6.30518 9.30518C5.91945 9.69092 5.91403 10.3146 6.293 10.707L8.293 12.707C8.6835 13.0974 9.3165 13.0974 9.707 12.707L13.707 8.707V8.707" fill="#FF5733" />
              </svg>
            </div>
            <span className="text-[#374151] font-medium text-sm leading-5">Deploy in hours</span>
          </div>
        </div>
      </div>
    </section>
  );
}
